import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { defaultStyles } from 'utils/Theme';
import classnames from 'classnames';
import Footer from 'components/layout/Partials/Footer';
import SidebarMenuContainer from 'components/layout/Partials/SidebarMenuContainer';
import { themeSelector } from 'redux/theme/selectors';

const AnalyticsLayout = ({ children }) => {
    const { sidebarVisibility } = useSelector(themeSelector);
    const [showMenu, setShowMenu] = useState(window.innerWidth > 1000);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
    }, []);

    const handleResize = (e) => {
        setShowMenu(window.innerWidth > 1000 ? true : false);
    };

    return (
        <div className={classnames('o-page')}>
            <SidebarMenuContainer />
            <main
                className={classnames('o-page__content', {
                    ' menu-hide': !sidebarVisibility,
                })}
            >
                {children}
                <Footer />
            </main>
        </div>
    );
};

AnalyticsLayout.propTypes = {
    children: PropTypes.any,
};

export default AnalyticsLayout;
